import { createStyles, Theme } from '@material-ui/core';

export const styles = ({ custom, breakpoints, palette }: Theme) =>
  createStyles({
    root: {
      width: '100%',
      '& input': {
        paddingRight: 20,
      },
    },
    adornmentHidden: {
      visibility: 'hidden',
    },
    adornmentDisplayNone: {
      display: 'none',
    },
    inputRootTravelResultsFilters: {
      marginBottom: 0,
      [breakpoints.up(960)]: {
        width: '100%',
      },
      '&>div': {
        height: 48,
        color: custom.grey[3],
        fontWeight: 500,
      },
    },
    mobileStaticSortAdornment: {
      fontSize: 14,
      lineHeight: '20px',
      padding: '8px 12px 8px 0',
      margin: 0,
      whiteSpace: 'break-spaces',
      [breakpoints.up(430)]: {
        borderRight: `solid 1px ${custom.grey[11]}`,
      },
    },
  });
